module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/calendar-7fdb8ed8c87d883bd2410178bd72ec7d.svg&quot;;"